import { render, staticRenderFns } from "./CollectCard.vue?vue&type=template&id=59bc7d40&scoped=true"
import script from "./CollectCard.vue?vue&type=script&lang=js"
export * from "./CollectCard.vue?vue&type=script&lang=js"
import style0 from "./CollectCard.vue?vue&type=style&index=0&id=59bc7d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc7d40",
  null
  
)

export default component.exports